module.exports = __webpack_public_path__ + "img/nonLive_icon.18ae1276.svg";